import { render, staticRenderFns } from "./asidePhone.vue?vue&type=template&id=eca293bc&scoped=true"
import script from "./asidePhone.vue?vue&type=script&lang=js"
export * from "./asidePhone.vue?vue&type=script&lang=js"
import style0 from "./asidePhone.vue?vue&type=style&index=0&id=eca293bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eca293bc",
  null
  
)

export default component.exports